"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boxClassName = exports.alertIcon = void 0;
var alertIcon = function (type) {
    switch (type) {
        case 'success':
            return 'is-check';
        case 'error':
            return 'is-error';
        case 'warning':
            return 'is-error';
        case 'info':
            return 'is-info-icon';
        default:
            return '';
    }
};
exports.alertIcon = alertIcon;
var boxClassName = function (type) {
    switch (type) {
        case 'success':
            return 'is-green-success';
        case 'error':
            return 'is-red-error';
        case 'warning':
            return 'is-orange-warning';
        case 'info':
            return '';
        default:
            return '';
    }
};
exports.boxClassName = boxClassName;
